import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const PiSquare: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['rect', { width: '18', height: '18', x: '3', y: '3', rx: '2' }],
    ['path', { d: 'M7 7h10' }],
    ['path', { d: 'M10 7v10' }],
    ['path', { d: 'M16 17a2 2 0 0 1-2-2V7' }],
  ],
];

export default PiSquare;
